import React from 'react';
import { Carousel } from 'antd';
import CarouselEvents from './CarouselEvents'; // relative path from DsyncGuide

/**
 * MainGuide
 *
 * Main tutorial page that hosts the carousel.
 */
const MainGuide = () => (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: 24 }}>
        <Carousel autoplay dotPosition="bottom">
            <div>
                <CarouselEvents />
            </div>
            {/* TODO: Add more slides such as <CarouselUsers />, <CarouselReports />, etc. */}
        </Carousel>
    </div>
);

export default MainGuide;
